import { useState } from "react";

import { CopyButton } from "~/components/CopyButton";
import { Input } from "~/components/input";

export function StoragePrefixes({ prefixes }: { prefixes: string[] }) {
  const [shard, setShard] = useState("");

  if (prefixes.length === 0) return null;

  const lastShard = prefixes.length - 1;
  const index = shard === "" ? 0 : Number(shard);
  const valid = Number.isInteger(index) && index >= 0 && index <= lastShard;
  const prefix = prefixes[valid ? index : 0];

  return (
    <div className="col-span-2 rounded-lg bg-gray-50 p-3">
      <div className="flex min-h-4 items-center justify-between gap-2">
        <span className="text-xs font-medium uppercase tracking-wide text-gray-500">
          Storage Prefix
        </span>

        {lastShard > 0 ? (
          <label className="flex items-center gap-1.5 font-mono text-xs text-gray-500">
            shard
            <Input
              type="number"
              inputMode="numeric"
              min={0}
              max={lastShard}
              value={shard}
              placeholder="0"
              aria-invalid={!valid}
              onChange={(event) => setShard(event.target.value)}
              className="h-7 w-16 px-2 font-mono text-xs focus-visible:border-input focus-visible:ring-1 focus-visible:ring-gray-300 aria-[invalid=true]:border-red-500 aria-[invalid=true]:text-red-600 aria-[invalid=true]:focus-visible:border-red-500 aria-[invalid=true]:focus-visible:ring-red-300"
            />
            / {lastShard}
          </label>
        ) : null}
      </div>

      <div className="mt-1 flex items-center gap-2 font-mono text-sm text-gray-900">
        <span className="min-w-0 break-all">{prefix}</span>
        <CopyButton value={prefix} label="Copy storage prefix" />
      </div>
    </div>
  );
}
